import React, { Suspense, lazy } from "react";
import { BrowserRouter } from "react-router-dom";

// ponytail: standalone Make List app. Auth, region and project selection live on the main
// Vizwalk site and reach this app via hand-off (query params / postMessage), not code here.
const MakeListApp = lazy(() => import("./makelist/MakeListApp"));

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div style={{ padding: 24 }}>Loading…</div>}>
        <MakeListApp />
      </Suspense>
    </BrowserRouter>
  );
}
